import { Reducer } from 'redux';
import { createReducer } from 'redux-act';

import { PagesActions } from '../pages/pages.actions';

import { LayoutActions } from './layout.actions';
import { LayoutState } from './layout.types';

const initialState: LayoutState = {
  navbar: false,
};

export const layout = createReducer(
  (on) => {
    on(LayoutActions.toggleNavbar, (state) => ({ ...state, navbar: !state.navbar }));

    on(PagesActions.selectPage, (state) => ({ ...state, navbar: false }));
  },
  initialState,
) as Reducer<LayoutState>;
